import styled from 'styled-components';

export const BreadcrumbGroupWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;
